var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6667 19.3335C30.8257 19.3335 29.3333 20.8259 29.3333 22.6668V26.0002L24.3333 26.0002H22.5434H21V29.3335H22.7815L24.1164 48.0231C24.3033 50.6396 26.4805 52.6668 29.1037 52.6668H42.8963C45.5195 52.6668 47.6967 50.6396 47.8836 48.0231L49.2185 29.3335H51V26.0002H49.4566H47.6667L42.6667 26.0002V22.6668C42.6667 20.8259 41.1743 19.3335 39.3333 19.3335H32.6667ZM39.3333 26.0002V22.6668H32.6667V26.0002H39.3333ZM26.1233 29.3335H45.8767L44.5587 47.7856C44.4964 48.6577 43.7707 49.3335 42.8963 49.3335H29.1037C28.2293 49.3335 27.5036 48.6577 27.4413 47.7856L26.1233 29.3335ZM37.6667 46.0002V32.6668H41V46.0002H37.6667ZM31 32.6668V46.0002H34.3333V32.6668H31Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBig);
export default __webpack_public_path__ + "static/media/remove-big.ced54888d4f6e5506c00d1c9f55adad9.svg";
export { ForwardRef as ReactComponent };